import { getTimeOfDay } from "@@/utilities/date-and-time/time-of-day";
import { repeatIndex } from "@@/utilities/repeat";
import { addDays, addSeconds, differenceInSeconds } from "date-fns";
import type { DurationInSeconds } from "../date-time/time-spans";
import { isoAndUnixFactory } from "./iso-and-unix";
import type { Time } from "./time";
import { SECONDS } from "./time-constants";
import type { TimeRange } from "./time-range";

type TimeSlot = TimeRange;

const isTimeSlot = (time: Time) => time._type === "TIME_RANGE";

const timeSlotToString = ({ start, end, duration }: TimeSlot) => {
    return duration
        ? `${getTimeOfDay(start)} - ${getTimeOfDay(end)}`
        : getTimeOfDay(start);
};

const timeSlotByDurationFactory = (
    start: Date,
    durationInMs?: number,
): TimeSlot => {
    const _end = new Date();
    if (durationInMs) {
        _end.setTime(start.getTime() + durationInMs);
    }
    return {
        _id: `${start.getTime()}-${_end.getTime()}`,
        _type: "TIME_RANGE",
        start: isoAndUnixFactory(start),
        end: isoAndUnixFactory(_end),
        duration: (durationInMs ? durationInMs / 1000 : 0) as DurationInSeconds,
    };
};

/** @deprecated its buggy and should be removed */
const timeSlotsByInBetweenDurationFactory = ({
    start,
    end,
    durationInSeconds,
    interval,
    perStartedDuration,
    tryToCorrectForDST,
}: {
    start: Date;
    end: Date;
    durationInSeconds: DurationInSeconds;
    interval?: DurationInSeconds;
    perStartedDuration?: boolean; //NAMING
    tryToCorrectForDST: boolean; //Tries to correct for DST (only possible if interval is DAY )
}): TimeSlot[] => {
    const totalSeconds = Math.abs(differenceInSeconds(end, start));

    const step = interval && interval > 0 ? interval : durationInSeconds;
    const numberOfSlots = Math.floor(totalSeconds / step);

    const isDaily = tryToCorrectForDST && step % 86_400 === 0;
    const dailyStep = step / 86_400;

    //Added +1 to quick fix problem with session creation,
    // den 2 juni kl 10 - 4 juni - kl 11 är 2 dagar så vart två tider
    //men är borde vara 3 dagar 2juni, 3juni och 4juni.
    //Finns säkert följdproblem med +1...
    const timeSlots = repeatIndex(
        numberOfSlots + (perStartedDuration ? 1 : 0),
    ).map(index => {
        const _start = isDaily
            ? addDays(start, index * dailyStep)
            : addSeconds(start, index * step);
        return timeSlotByDurationFactory(_start, durationInSeconds * SECONDS);
    });

    return timeSlots;
};

const timeSlotFactory = (start: Date, end: Date): TimeSlot => {
    const diffInMs = Math.round(Math.abs(start.getTime() - end.getTime()));
    const timeR = timeSlotByDurationFactory(start, diffInMs);

    return timeR;
};

export {
    isTimeSlot,
    timeSlotByDurationFactory,
    timeSlotFactory,
    timeSlotsByInBetweenDurationFactory,
    timeSlotToString,
};
export type { TimeSlot };
